import Vue from 'vue'
import Router from 'vue-router'
import Home from '../components/Home.vue'


Vue.use(Router)

const router = new Router({
  routes: [
    { path: '/', redirect: '/home' },
    { path: '/home', component: Home, meta:{title:"实训错题集"} },
  ]
})
const originalPush = Router.prototype.push
Router.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
  return originalPush.call(this, location).catch(err => err)
}
// 挂载路由导航守卫
// router.beforeEach((to, from, next) => {
//   // to 将要访问的路径
//   // from 代表从哪个路径跳转而来
//   // next 是一个函数，表示放行
//   //     next()  放行    next('/home')  强制跳转

//   if (to.path === '/home') return next()
//   if (to.path === '/test') return next()
//   if (to.path === '/login') return next()
//   if (to.path === '/knowledge') return next()
//   if (to.path === '/mon') return next()
//   // 获取token
//   const tokenStr = window.sessionStorage.getItem('token')
//   if (!tokenStr) return next('/login')
//   next()
// })

export default router
